export const CLEAR = 'CLEAR';
export const BUSINESS_UNIT_CONTACT_DETAILS = 'BUSINESS_UNIT_CONTACT_DETAILS';
